import React from 'react';
import { connect } from 'react-redux';

import { ILoginState, IMenuState } from '@share/store/slices';
import { TRAVCODING_HOME_TEMPLATE } from '@share/common-types';
import { HomeRsi, HomeRsiUpgrade, HomeTravcoding, HomeModern, HomeHilton } from '@components';
import { RootState, scrollTop } from '@share/utils';
import {
  RSI_UPGRADE_ELITE_PROFILE,
  RSI_UPGRADE_OLD_PROFILE,
  RSI_UPGRADE_PRIME_PROFILE,
  HILTON_WORLDWIDE_PROFILE,
} from '@share/constants';

import './style.scss';

interface IMapStateToProps {
  loginStore: ILoginState;
  menuStore: IMenuState;
}

interface IProps extends IMapStateToProps {}

class HomePageComponent extends React.Component<IProps> {
  constructor(props: IProps) {
    super(props);

    scrollTop();
  }

  render(): React.ReactNode {
    const { loginStore, menuStore } = this.props;
    const { account } = loginStore;
    const { items } = menuStore;

    const homePageTemplate = account?.homePageTemplate;
    const isRSITemplate = account?.isRSITemplate;
    const profile = items?.profile;
    const isRsiUpgradeEliteProfile = profile === RSI_UPGRADE_ELITE_PROFILE;
    const isRsiUpgradePrimeProfile = profile === RSI_UPGRADE_PRIME_PROFILE;
    const isRsiUpgradeOldProfile = profile === RSI_UPGRADE_OLD_PROFILE;
    const isHiltonProfile = profile === HILTON_WORLDWIDE_PROFILE;
    const isRsiUpgrade =
      isRsiUpgradeEliteProfile || isRsiUpgradePrimeProfile || isRsiUpgradeOldProfile;

    // Check if Modern template should be used (both SiteId AND OrgId must match)
    const siteId = items?.siteId;
    const organizationId = items?.organizationId;
    const modernHomeTemplateOrgidList = account?.modernHomeTemplateOrgidList;
    const modernHomeTemplateSiteidList = account?.modernHomeTemplateSiteidList;

    const isInModernOrgId = modernHomeTemplateOrgidList?.includes(
      organizationId?.toString() as string,
    );
    const isInModernSiteId = modernHomeTemplateSiteidList?.includes(siteId?.toString() as string);

    const useModernTemplate =
      isRSITemplate &&
      ((isInModernOrgId && isInModernSiteId) || (account?.isModernTemplate));

    return (
      <div className="home-page">
        {(!homePageTemplate || homePageTemplate === TRAVCODING_HOME_TEMPLATE) && <HomeTravcoding />}
        {useModernTemplate && <HomeModern />}
        {isRSITemplate && !useModernTemplate && isHiltonProfile && <HomeHilton />}
        {isRSITemplate && !useModernTemplate && !isRsiUpgrade && !isHiltonProfile && <HomeRsi />}
        {isRSITemplate &&
          !useModernTemplate &&
          (isRsiUpgradeEliteProfile || isRsiUpgradePrimeProfile) && <HomeRsi />}
        {isRSITemplate && !useModernTemplate && isRsiUpgradeOldProfile && <HomeRsiUpgrade />}
      </div>
    );
  }
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    loginStore: state.loginStore,
    menuStore: state.navigationMenuStore,
  };
};

export const HomePage = connect(mapStateToProps)(HomePageComponent);
